import * as Yup from "yup";
import { ArtistTermsSchemaFragment } from "../../../common/components/ArtistTermsAndConditions/ArtistTermsSchemaFragment";

export const convertProfileValidationSchema = Yup.object().shape({
  ...ArtistTermsSchemaFragment,
});
